import { useEffect, useState } from "react";
import TicketDraftApi from "../../../api/TicketDraftApi";
import TicketForm from "./ticketForm";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { Box } from "@mui/material";
import { getSessionStorage, removeSessionStorage } from "../../../utils/StorageUtil";
import TicketApi from "../../../api/TicketApi";
import SuccessDialog from "./ticketForm/succesDialog"
import UnitsApi from "../../../api/UnitsApi";
import { useNavigate } from "react-router-dom";

export default  () => {
  const [step, setStep] = useState(-1)
  const [companyName, setCompanyName] = useState('')
  const [plateNumber, setPlateNumber] = useState('')
  const [ticketId, setTicketId] = useState('')
  const [Unit404DialogOpen, setUnit404DialogOpen] = useState(false)
  const [SuccessDialogOpen, setSuccessDialogOpen] = useState(false)
  const [showBackdrop, setShowBackDrop] = useState(true)
  const [ticketNumber, setTicketNumber] = useState('')
  const [ticketStatus, setTicketStatus] = useState('')
  const navigate = useNavigate()

  const handleUnload = () => removeSessionStorage('draft-maintenance')

  useEffect(() => {
    const data = getSessionStorage('draft-maintenance')
    if (!!data) {
      setAssistanceData(data.domain, data)
    } else {
      setStep(0)
      setShowBackDrop(false)
    }

    window.addEventListener('beforeunload', handleUnload);
    return () => { window.removeEventListener('beforeunload', handleUnload) }
  }, []);

  const setAssistanceData = (PlateNumber: string, data: any) => {
    console.log(data.id)
    setCompanyName(data.company.name)
    setPlateNumber(PlateNumber)
    setTicketId(data.id)
    setStep(1)
    setShowBackDrop(false)
  }

  const createAssistance = (values: any) => {
    setShowBackDrop(true)
    return TicketDraftApi.post(values.domain)
    .then((response) => {
      setAssistanceData(values.PlateNumber, response.data)
    }).catch(() => {
      setUnit404DialogOpen(true)
      setShowBackDrop(false)
    })
  }

  const handleDomainSearch = (values: any, actions: any) => {
    createAssistance(values).finally(() => actions.resetForm())
  }

  const handleForm = (values: any, id: any) => {
    setShowBackDrop(true)
    TicketApi.patch(id, { ...values, status: 'AUTORIZADA' })
    .then((response: any) => {
      if (!response.data.idTicket) return
      setTicketNumber(response.data.idTicket)
      setTicketStatus(response.data.status)
      setSuccessDialogOpen(true)
    }).finally(() => {
      setShowBackDrop(false)
    })
  }

  const handleReject = (id: string,remarksClient:string) => {
    setShowBackDrop(true)
    TicketApi.patch(id, { status: 'RECHAZADA',remarksClient: remarksClient })
      .then((response: any) => {
        if (!response.data.idTicket) return
        setTicketNumber(response.data.idTicket)
        setTicketStatus(response.data.status)
        setSuccessDialogOpen(true)
      })
      // .finally(() => {
      //   setShowBackDrop(false)
      //   setSuccessDialogOpen(false)
      // })
  }

  const handleAuthorize = (values: any, id: string) => {
    setShowBackDrop(true)
    TicketApi.patch(id, { ...values, status: 'AUTORIZADA' })
      .then((response: any) => {
        if (!response.data.idTicket) return
        setTicketNumber(response.data.idTicket)
        setTicketStatus(response.data.status)
        setSuccessDialogOpen(true)
      })
      .finally(() => {
        setShowBackDrop(false)
        setSuccessDialogOpen(false)
      })
  }

  const handleSuccessDialogClose = () => {


    setSuccessDialogOpen(false)
    setShowBackDrop(true)
    // goToConsulMaintenance()
    navigate(`/web/`)
    handleUnload()
  }

  const goToConsulMaintenance = () => {
    UnitsApi.filterByDomain(plateNumber)
    .then((result: any) => {
      setShowBackDrop(false)
      navigate(`/web/consult-maintenance/${plateNumber}/${result.data[0].id}`)
    })
  }

  const handleGoBack = () => {
    handleUnload()
    if (!plateNumber.length) navigate(`/web/search-vehicles`,{ replace: true })
    else goToConsulMaintenance()
  }

  const renderInfo = () => {
    return <TicketForm companyName={companyName} ticketId={ticketId} plateNumber={plateNumber} handleSubmit={handleForm} handleReject={handleReject} handleGoBack={handleGoBack} />

  }

  return (
    <Box>
      { renderInfo() }
      <Backdrop sx={{ color: '#fff' }} open={showBackdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <SuccessDialog open={SuccessDialogOpen} handleClose={handleSuccessDialogClose} plateNumber={plateNumber} ticketNumber={ticketNumber} status={ticketStatus}></SuccessDialog>
    </Box>
  )
}
